const state = {
    selectedTierObj: null,
    selectedPricingObj: null,
   // isEdit:false
};
//gettters
const getters = {


    GET_SELECTED_TIER: (state) => {
        return state.selectedTierObj;
    },
    GET_SELECTED_PRICING: (state) => {
        return state.selectedPricingObj;
    },
    // GET_ISEDIT: () => {
    //     return state.isEdit;
    // }
};
//actions
const actions = {
    CLEAR_ASSIGN_PRICING_STORE: ({ commit }) => {
        commit('clearAssignPricingStore');
    },
    SET_SELECTED_TIER: ({ commit }, selectedTierObj) => {
        commit("saveSelectedTier", selectedTierObj);
    },
    SET_SELECTED_PRICING: ({ commit }, selectedPricingObj) => {
        commit("saveSelectedPricing", selectedPricingObj);
    },
    // SET_ISEDIT: ({ commit }, isEdit) => {
    //     commit("saveIsEdit", isEdit);
    // },

};
//mutations

const mutations = {
    clearAssignPricingStore(state) {

        state.selectedTierObj = null;
        state.selectedPricingObj = null;
    },



    saveSelectedTier(state, selectedTierObj) {
        state.selectedTierObj = selectedTierObj;
    },
    saveSelectedPricing(state, selectedPricingObj) {
        state.selectedPricingObj = selectedPricingObj;
    },
    // saveIsEdit(state, isEdit) {
    //     state.isEdit = isEdit;
    // },


};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};